<template>
    <modal title="" width="35" :showModal="showModal" @close-modal="closeModal">
      <div
        v-for="(filter, index) in activefilterOption"
        :key="index"
        class="w-[350px] flex w-full items-center filter-item"
      >
        <img
          alt=""
          class="w-6 mr-2"
          src="@/assets/images/billing/fleets-icon.svg"
        />
        <span class="w-full">{{filter.name}}</span>
        <i class="w-6"><eye :color="filter.active ? '#FCC210' : '#cbd5e0'"/></i>
      </div>
      <div class="divider"></div>
      <div>
        <div
          v-for="(filter, index) in deactivefilterOption"
          :key="index"
          class="w-[350px] flex w-full items-center  filter-item"
        >
          <img
            alt=""
            class="w-6 mr-2"
            src="@/assets/images/billing/fleets-icon.svg"
          />
          <span class="w-full">{{filter.name}}</span>
          <i class="w-6"><eye :color="filter.active ? '#FCC210' : '#cbd5e0'"/></i>
        </div>
      </div>
    </modal>
  </template>
  
  <script>
  import eye from "@/assets/images/billing/eye.vue";
  export default {
    components: {
      eye,
    },
    methods: {
      closeModal() {
        this.$emit("close-modal");
      },
    },
    computed: {
      activefilterOption(){
          return this.filterOptions.filter((item) => item.active)
      },
      deactivefilterOption(){
          return this.filterOptions.filter((item) => !item.active)
      }
    },
    data() {
      return {
        filterOptions: [
          { name: "Transaction Date", active: true },
          { name: "Shipping ID", active: true },
          { name: "Route", active: true },
          { name: "Destination", active: true },
          { name: "Gross Weight", active: true },
          { name: "Total Shipping Cost", active: true },
          { name: "Mode of Payment", active: true },
          { name: "Payment Date", active: true },
          { name: "Customer", active: false },
          { name: "Origin", active: false },
          { name: "Destination", active: false },
        ],
      };
    },
    props: {
      showModal: {
        type: Boolean,
        required: true,
      },
    },
  };
  </script>
  
  <style scoped lang="scss">
  .label {
    @apply border-b-2 border-gray-400 w-full pb-1;
    font-size: 13px;
  }
  .individual-contaoner {
    @apply w-full border-2 border-gray-300 border-dashed p-2 my-3;
  }
  .filter-search {
    border-radius: 4px;
    @apply py-2;
  }
  .filter-item{
    @apply py-2 opacity-75
  }
  .divider{
      @apply border-gray-300 w-full;
      border-top-width: 1px;
    }
  </style>
  